/* Keyframes */
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(320deg);
  }
  100% {
    transform: rotate(720deg);
  }
}

@keyframes dashoffset {
  0%,
  100% {
    stroke-dashoffset: 96;
    transform: rotate(0deg);
  }

  30% {
    stroke-dashoffset: 40;
    transform: rotate(-106deg);
  }
}

/* Main container */
.spinner {
  /* Base styles */
  animation-fill-mode: forwards;
  animation-name: fadeIn;
  animation-timing-function: var(--transitions-eases-ease-in-out);
  opacity: 0;
  pointer-events: none;
  position: relative;

  /* Centered state */
  &:where([data-centered]) {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

/* SVG rings container */
.rings {
  animation: rotate 1.4s linear infinite;
}

/* Ring stroke */
.ringStroke {
  animation: dashoffset 1.4s linear infinite;
  transform-origin: center;
}
